<template>
  <div class="bsStatics">
    <div class="block" style="float: left; margin: 20px 50px;">
      <el-date-picker
        v-model="value1"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份">
      </el-date-picker>
      <el-button style="background-color: #FF9000; color: #FFFFFF; margin-left: 10px">搜索</el-button>
      <el-button type="info">清空</el-button>
    </div>
    <div id="statics" style="width: 700px; height: 300px; float: left; margin-top: 80px; margin-left: -100px">
    </div>
    <div class="elTable">
      <el-table
        :data="tableData"
        border
        style="width: 100%;
      margin-left: 420px;
      float: left;
      margin-top: 70px;">
        <el-table-column
          prop="date"
          label="日期"
          width="180">
        </el-table-column>
        <el-table-column
          prop="addStore"
          label="新增商户数"
          width="180">
        </el-table-column>
        <el-table-column
          prop="yay"
          label="环比">
        </el-table-column>
        <el-table-column
          prop="mam"
          label="同比">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: 'BsStatics',
  data() {
    return {
      value1: '',
      tableData: [{
        date: '2016-05-02',
        addStore: '200',
        yay: '+45%',
        mam: '30%'
      },
        {
          date: '2016-05-02',
          addStore: '200',
          yay: '+45%',
          mam: '30%'
        },
        {
          date: '2016-05-02',
          addStore: '200',
          yay: '+45%',
          mam: '30%'
        }]
    }
  },
  methods: {
    initCharts() {
      let myChart = echarts.init(document.getElementById('statics'))
      myChart.setOption({
        color: ['#FF9000'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['一月', '二月', '三月', '四月', '五月', '六月'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '增长数量',
            type: 'bar',
            barWidth: '50%',
            data: [100, 52, 200, 334, 390, 330, 220]
          }
        ]
      })
    }
  },
  mounted() {
    this.initCharts()
  }
}
</script>

<style scoped>
body {
  display: flex;
}

.bsStatics {
  margin: 0px 0px 0px 0px;
  background-color: #f2f2f2;
  width: 1630px;
  height: 750px;
}

.elTable {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/usermanagement/bsstatics.vue